export default "__VITE_ASSET__uYyt99C4__"